export default __webpack_public_path__ + "static/media/keto_water@2x.2d72da2b.jpg";